export default __webpack_public_path__ + "static/PPNeueMontreal-SemiBold-cf99e2e9c752f0b1a0eb52b983615902.ttf";